import { InjectionToken } from '@angular/core';
import { IConstraint } from '@se/constraint';
import { Observable } from 'rxjs';

import type { ICustomPage, IDataset, IPlaceholders, IServerDataSource, Json, JsonObject } from '@se/cp.common';

export interface ICustomPageLayoutData {
    constraints: IConstraint[];
    dataSources: IServerDataSource;
    dataset: IDataset;
    idModelTypes: string[];
    layout: ICustomPage;
    placeholders: IPlaceholders;
}

export interface ICustomPageMasterData extends ICustomPageLayoutData {
    idCustomPage: string;
    model: JsonObject;
}

export interface ICustomPageMasterDataResolver {
    getCustomPageRoot(): string;

    getModelTypes(): string[];

    getLayout(idCustomPage: string): Observable<ICustomPageLayoutData>;

    getMasterData(): Observable<ICustomPageMasterData>;

    getData(): Observable<Json>;
}

export const CustomPageMasterDataResolver = new InjectionToken('CustomPageMasterDataResolver');
